import { Grid } from "@mui/material";
import { useFormContext } from "react-hook-form";
import { BorderedFormGrid } from "../../Forms/BorderedFormGrid";
import { UPPERCASE_INPUT } from "../../Forms/formStyles";
import { CountrySelect } from "../../Locations/CountrySelect";
import Carrier from "../Carrier";
import { TextFieldInput } from "../../Forms/TextFieldInput";
import { MdmFormProps } from "../../Forms/MdmFormProps";

export function CarrierForm({ disabledFields }: MdmFormProps) {
  const { control } = useFormContext<Carrier>();

  return (
    <Grid container>
      <Grid item xs={12}>
        <BorderedFormGrid>
          <Grid item xs={3}>
            <TextFieldInput
              name="Name"
              control={control}
              required
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={3}>
            <TextFieldInput
              name="Gsdb"
              control={control}
              label="Contract GSDB"
              required
              disabledFields={disabledFields}
              inputProps={UPPERCASE_INPUT}
            />
          </Grid>
          <Grid item xs={3}>
            <TextFieldInput
              name="CarrierManager"
              control={control}
              label="Carrier Manager"
              disabledFields={disabledFields}
            />
          </Grid>

          {/* Placeholder */}
          <Grid item xs={3} />
        </BorderedFormGrid>
      </Grid>

      <Grid item xs={3}>
        <BorderedFormGrid>
          <Grid item xs={12}>
            <TextFieldInput name="Street" control={control} disabledFields={disabledFields} />
          </Grid>
          <Grid item xs={12}>
            <TextFieldInput
              name="Zip"
              control={control}
              label="Postcode"
              disabledFields={disabledFields}
            />
          </Grid>
          <Grid item xs={12}>
            <TextFieldInput name="City" control={control} disabledFields={disabledFields} />
          </Grid>
          <Grid item xs={12}>
            <CountrySelect control={control} name="CountryId" required />
          </Grid>
        </BorderedFormGrid>
      </Grid>

      {/* Placeholder */}
      <Grid item xs={9} />
    </Grid>
  );
}
